import {atom} from 'jotai';
import {userAtom} from '@/store/user';
import {getUserStats, getUsageData, getRecentRenders} from '@/actions/homepage';
import type {UsageData, UserStats, Render} from '@/types/dashboard';

export const userStatsAtom = atom<UserStats>();

export const getUserStatsAtom = atom(null, async (get, set) => {
    const user = get(userAtom);
    if (!user?.auth_token) return;
    const data = await getUserStats(user);

    set(userStatsAtom, data);

    return data;
});

export const userUsageAtom = atom<UsageData>();

export const getUserUsageAtom = atom(null, async (get, set) => {
    const user = get(userAtom);
    if (!user?.auth_token) return;
    const data = await getUsageData(user);

    set(userUsageAtom, data);

    return data;
});

export const recentRendersAtom = atom<{
    items: Render[];
    total: number;
    loading: boolean;
    initialized: boolean;
}>({
    items: [],
    total: 0,
    loading: false,
    initialized: false,
});

export const getRecentRendersAtom = atom(null, async (get, set) => {
    set(recentRendersAtom, (prev) => ({
        ...prev,
        loading: true,
    }));

    try {
        const data = await getRecentRenders();

        set(recentRendersAtom, {
            items: data.items,
            total: data.total,
            loading: false,
            initialized: true,
        });

        return data.items;
    } catch (error) {
        set(recentRendersAtom, (prev) => ({
            ...prev,
            loading: false,
            initialized: true,
        }));

        throw error;
    }
});
